const changeValuesByPath = (obj, path, value) => {
  const pathArray = path.split(/\.|\[|\]/).filter(Boolean);
  const newObj = Array.isArray(obj) ? [...obj] : { ...obj };
  let currentObj = newObj;

  for (let i = 0; i < pathArray.length - 1; i++) {
    const key = pathArray[i];

    if (!(key in currentObj)) {
      const nextKey = pathArray[i + 1];
      currentObj[key] = isNaN(nextKey) ? {} : [];
    }

    currentObj[key] = Array.isArray(currentObj[key]) ? [...currentObj[key]] : { ...currentObj[key] };
    currentObj = currentObj[key];
  }

  let lastKey = pathArray[pathArray.length - 1];
  if (!isNaN(lastKey)) lastKey = Number(lastKey);

  currentObj[lastKey] = value;
  return newObj;
};

export const FormState = {
  changeValuesByPath,
};